import { motion } from 'framer-motion'
import React, { useRef } from 'react'
import { useClickAway, useMedia } from 'react-use'
import styled, { css } from 'styled-components'
import { media, phoneMaxWidth } from 'utils/media'
import { useAlgoliaSearchContext } from 'modules/brands/list/components/controllers/AlgoliaSearchContext'
import { NavbarSearchModal } from './components/NavbarSearchModal'
import { SearchButton } from './components/SearchButton'

const OuterContainer = styled(motion.div)``

const Container = styled(motion.div)<{ open: boolean }>`
  padding: 0;
  display: flex;
  align-items: center;
  width: 66px;
  border-left: var(--border);
  border-right: var(--border);
  height: var(--header-height);
  z-index: 1;

  ${media.tabletDown} {
    ${(props) =>
      props.open &&
      css`
        z-index: 1002;
        top: 0px;
      `}
  }

  ${media.phoneDown} {
    margin-left: 0;
    margin-right: 0;
    border-right-color: var(--black-20);
    border-left-color: var(--black-20);
    width: 56px;
  }
`

interface Props {
  children?: React.ReactNode
  className?: string
}

export const GlobalSearch = ({ children, className }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { isModalOpen, openModal, closeModal } = useAlgoliaSearchContext()

  const isDesktop = useMedia(`(min-width: ${phoneMaxWidth}px)`)
  useClickAway(containerRef, () => {
    if (isDesktop) {
      closeModal()
    }
  })

  return (
    <OuterContainer className={className} animate={isModalOpen ? 'open' : 'closed'} ref={containerRef}>
      {children}
      <Container open={isModalOpen}>
        <SearchButton onClick={openModal} />
        <NavbarSearchModal />
      </Container>
    </OuterContainer>
  )
}
